
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M7.543 11.543l5.292-5.292a1.05 1.05 0 10-1.486-1.485L7.543 8.573 3.735 4.765a1.047 1.047 0 00-1.484 0 1.049 1.049 0 000 1.485l5.292 5.293"}})])])
          )
        }
      }
    